import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge31 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='相場が上下する会員権の見分け方' fontWeight={700} />
                <p>
                    ゴルフ会員権の相場を左右する要因については
                    <a href='/knowledge/25'>ゴルフ会員権の全国相場データ・価格動向の見方</a>
                    で全体像をご紹介しましたが、本記事では「今後相場が上がりやすい会員権」と「下がりやすい会員権」を見分けるための具体的なチェックポイントを整理します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相場が下がりやすい会員権の特徴' fontWeight={700} />

                <Heading3 title='預託金の据置期間がまだ長く残っている' />
                <p>
                    預託金の返還時期が先であるほど、購入者にとっては資金が長期間拘束されることになるため、同じ取引価格であっても敬遠されやすく、相場が軟調になりやすい傾向があります。
                </p>

                <Heading3 title='運営会社の経営状態に懸念がある' />
                <p>
                    運営会社の財務状況が悪化している、あるいは経営権の異動が続いているクラブは、預託金の回収可能性への不安から相場が下落しやすくなります。運営会社の経営状態は、会員権を検討する際に必ず確認すべきポイントの一つです。
                </p>

                <Heading3 title='会員数政策が緩和されている' />
                <p>
                    経営上の理由から会員数を積極的に増やしている場合、需給バランスが緩み、相場が下落方向に働くことがあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相場が上がりやすい会員権の特徴' fontWeight={700} />

                <Heading3 title='預託金の据置期間が短い、または返還済み' />
                <p>
                    据置期間が満了に近い、あるいはすでに預託金が返還されている会員権は、実質的な負担額が明確になるため、相対的に評価されやすくなります。
                </p>

                <Heading3 title='エリアの再開発・利便性向上' />
                <p>
                    周辺エリアで交通インフラの整備や都市開発が進むと、アクセスの向上によって需要が高まり、相場が上昇に転じることがあります。
                </p>

                <Heading3 title='会員数を厳格に管理している' />
                <p>
                    意図的に会員数を絞って希少性を維持している名門クラブは、相場が底堅く推移しやすい傾向があります。名門クラブ特有の傾向は
                    <a href='/knowledge/30'>名門・高額帯クラブの相場動向</a>
                    で詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相場判断で注意したいこと' fontWeight={700} />
                <p>
                    これらのチェックポイントはあくまで一般的な傾向であり、実際の相場は個別のクラブごとの事情によって大きく異なります。「値上がりが期待できそうだから」という理由だけで購入判断をするのではなく、ご自身の利用目的（プレー頻度・アクセス・法人利用の有無など）を優先したうえで、相場動向を参考情報として活用することをおすすめします。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の相場は、預託金の据置期間・運営会社の経営状態・会員数政策・エリアの利便性など複数の要素によって上下します。個別の会員権の相場見通しについては、住地ゴルフの担当者までお気軽にご相談ください。
                    <br />
                    全国的な相場の考え方は<a href='/knowledge/25'>こちら</a>もあわせてご確認ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge31;
